import { useTranslation } from 'next-i18next'

import { months } from '~/components/Calendar/constants'

export default function CalendarHeader({ selectedDate }: { selectedDate: Date }): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <header className="flex items-center justify-between">
      <span className="text-lg font-bold">{t(`monthsLong.${months[selectedDate.getMonth()]}`)}</span>
      <span className="text-lg">{selectedDate.getFullYear()}</span>
    </header>
  )
}
